/**
 * @file index.tx
 *
 * @fileoverview If a user has multiple organizations, show the currently selected one.
 */
import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { UserContext, UserContextInterface } from '~/jobiqo/context/user';
import FlexItems from '~/vcl/atoms/06-layout/03-flex';
import { Box } from '~/vcl/atoms/07-box';
import Avatar from '~/vcl/atoms/12-user/01-avatar';
import { Text } from '~/vcl/atoms/13-text/03-text';

export interface JobWizardCurrentOrgProps {
  /**
   * The prefix label to display.
   */
  prefixLabel?: boolean;
}

export function JobWizardCurrentOrg({ prefixLabel }: JobWizardCurrentOrgProps) {
  const {
    currentOrganizationProfile,
    updatableOrganizationProfiles,
  }: UserContextInterface = useContext(UserContext);

  if (updatableOrganizationProfiles?.length <= 1) {
    return null;
  }

  const label = (
    <FormattedMessage
      id="job_wizard_current_org_prefix"
      defaultMessage="Posting job for"
    />
  );

  const Component = prefixLabel ? 'div' : Box;

  return (
    currentOrganizationProfile && (
      <Component label={label}>
        <FlexItems flexWrap="nowrap" gap={5} alignItems="center">
          {prefixLabel && (
            <Text tag="span" fontWeight="bold">
              {label}:{' '}
            </Text>
          )}
          <Avatar
            alt={currentOrganizationProfile.name}
            title={currentOrganizationProfile.name}
            size="small"
            src={currentOrganizationProfile?.logo?.url}
          />
          <Text marginTop={0}>{currentOrganizationProfile.name}</Text>
        </FlexItems>
      </Component>
    )
  );
}
